import useProject from 'hooks/useProject';
import { useMemo } from 'react';
import { Position } from 'reactflow';
import { ModelDirection } from 'types';

const useHandlePosition = (modelDirection?: ModelDirection) => {
  const project = useProject({ enabled: !modelDirection });

  const handlePosition = useMemo(() => {
    if (project.data?.direction === 'horizontal') {
      return {
        target: Position.Left,
        source: Position.Right,
      };
    } else {
      return {
        target: Position.Top,
        source: Position.Bottom,
      };
    }
  }, [project]);

  return {
    handlePosition,
  };
};

export default useHandlePosition;
